import { z } from 'zod'

export const envSchema = z.object({
  VITE_API_URL: z.string(),
  VITE_IS_DEV: z.string().or(z.coerce.boolean()).optional(),
  VITE_SENTRY_DNS_URL: z.string(),
  VITE_STATIC_DOMAIN: z.string(),
  VITE_VAPID_PUBLIC_KEY: z.string(),
  VITE_OTLP_URL: z.string().optional(),
})

export type Env = z.infer<typeof envSchema>

export const parseEnv = () => {
  const results = envSchema.safeParse(import.meta.env)

  if (results.success) return results.data

  console.log({ error: results.error.errors })

  throw new Error(results.error.errors.join('\n'))
}

export const env = parseEnv()
